module.exports = __webpack_public_path__ + "static/media/60.15b56a9f.jpg";